export default "__VITE_ASSET__Dh5CViv6__"